import Dashboard from '../components/dashboard/Dashboard';

export default Dashboard;
